var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from 'mobx';
import { GreyCat } from '@greycat/core';
import { serializable } from 'serializr';
export default class ConsoleStore {
    constructor() {
        this.logs = [];
        this.level = 'log';
        GreyCat.Logger = this;
    }
    log(...args) {
        // tslint:disable-next-line:no-console
        console.log.call(console, ...args);
        this._push({ time: Date.now(), level: 'log', message: this._convert(args) });
    }
    info(...args) {
        // tslint:disable-next-line:no-console
        console.info.call(console, ...args);
        this._push({ time: Date.now(), level: 'info', message: this._convert(args) });
    }
    debug(...args) {
        // tslint:disable-next-line:no-console
        console.debug.call(console, ...args);
        this._push({ time: Date.now(), level: 'debug', message: this._convert(args) });
    }
    warn(...args) {
        // tslint:disable-next-line:no-console
        console.warn.call(console, ...args);
        this._push({ time: Date.now(), level: 'warn', message: this._convert(args) });
    }
    error(...args) {
        // tslint:disable-next-line:no-console
        console.error.call(console, ...args);
        this._push({ time: Date.now(), level: 'error', message: this._convert(args) });
    }
    clear() {
        this.logs.length = 0;
    }
    _push(log) {
        // logs array is limited to 1000 items
        if (this.logs.length >= 1000) {
            this.logs.splice(0, (this.logs.length - 1000) + 1);
        }
        this.logs.push(log);
    }
    _convert(args) {
        // tslint:disable-next-line:no-console
        console.log('ConsoleStore._convert', args);
        return args.map((a) => {
            if (a instanceof Error) {
                return a.stack;
            }
            if (typeof a === 'object') {
                return JSON.stringify(a, null, 2);
            }
            return a;
        }).join(' ');
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], ConsoleStore.prototype, "logs", void 0);
__decorate([
    observable,
    serializable,
    __metadata("design:type", String)
], ConsoleStore.prototype, "level", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ConsoleStore.prototype, "clear", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConsoleStore.prototype, "_push", null);
